require('dotenv');
const axios = require('axios').default;

let LogTimesheetsApi = {

    endpoint : "LogTimesheets/",


    async update(timesheetIds) {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint;

        const response = await axios.post(URL, timesheetIds, { withCredentials: true });
        return response.data;
    }
}



export { LogTimesheetsApi }